import React from 'react';
import styles from './index.module.scss';

function ChatLoading({ content }: { content?: string }) {
  return (
    <div className={styles['chat-loading']}>
      <div className={styles.content}>
        <img className={styles['loading-img']} src="https://imgcdn.sto.cn/4252D50F-048D-47-32x32-loading.png" alt="" />
        {content || '思考中...'}
      </div>
    </div>
  );
}

export default ChatLoading;
